import { render, staticRenderFns } from "./syncPartnerGoodsPrice.vue?vue&type=template&id=3f7975dc"
import script from "./syncPartnerGoodsPrice.vue?vue&type=script&lang=js"
export * from "./syncPartnerGoodsPrice.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports